export default __webpack_public_path__ + "static/media/man.09e55d65.jpg";